import React from 'react';
import { useLocation, Switch } from 'react-router-dom';
import { FourOhFourErrorPage } from '@sm/webassets';

import Layout from '~pricing/components/Layout';
import pages from '~pricing/pages';
import useTreatment from '~pricing/hooks/useTreatment';
import { PricingStateProvider } from '~shared/hooks/usePricingState';
import usePackageSet from './hooks/usePackageSet';
import { PackageType } from '~shared/types/pricing/package';
import { getPackagesBasedOnQueryStringIds } from './lib/lib-helpers';

import PricingRoutes from './PricingRoutes';
import { ROOT_PRICING_ROUTE } from '~shared/constants/pricing';

const PricingRouter = (): JSX.Element => {
  const { search, pathname } = useLocation();
  const query = new URLSearchParams(search);
  let canonicalPath = PackageType.Teams;
  let subPath;

  if (pathname.includes(PackageType.Individual)) {
    canonicalPath = PackageType.Individual;
  }

  if (pathname.includes(PackageType.Educational)) {
    canonicalPath = PackageType.Educational;
  }

  if (pathname.includes('details')) {
    subPath = 'details';
  }

  const { packageSet } = usePackageSet(canonicalPath);

  const comparePlans = query.get('compare_plans');

  const {
    uiExperiment: { ENTERPRISE_FEATURES_GP69 },
  } = useTreatment();

  // GP-69: this experiment is a full page take over for enterprise users
  // viewing the pricing pages and doesn't fit into the standard page layout.
  // we'll let it provide all of its own <BasePage> stuff as necessary

  if (ENTERPRISE_FEATURES_GP69) {
    return <ENTERPRISE_FEATURES_GP69.EnterpriseFeatures />;
  }

  return (
    <Layout>
      <PricingStateProvider
        packagesToDisplay={comparePlans ? getPackagesBasedOnQueryStringIds(comparePlans, canonicalPath) : packageSet}
        showEduDiscount={canonicalPath === PackageType.Educational}
        comparePlans={Boolean(comparePlans)}
        canonicalPath={canonicalPath}
        subPath={subPath}
      >
        <Switch>
          {pages().map(page =>
            page.paths.map((path: string) => (
              <PricingRoutes
                key={path}
                path={path}
                exact
                redirectPath={ROOT_PRICING_ROUTE}
                component={page.component}
              />
            ))
          )}
          <FourOhFourErrorPage />
        </Switch>
      </PricingStateProvider>
    </Layout>
  );
};

export default PricingRouter;
